import React, { FC } from 'react';
import Link from '../CustomNextLink';
import { BreadcrumbProps } from './';

export const BreadcrumbsTemplate: FC<BreadcrumbProps> = ({ className, items }) => {
    return (
        <div className={className}>
            {items.map((item, idx) =>
                idx !== items.length - 1 ? (
                    <Link href={item.url} key={item.idx}>
                        <a>{item.text}</a>
                    </Link>
                ) : (
                    <span key={item.idx}>{item.text}</span>
                )
            )}
        </div>
    );
};
